import { render } from "./BaseDraggableWindow.vue?vue&type=template&id=0ea158d7&scoped=true"
import script from "./BaseDraggableWindow.vue?vue&type=script&lang=js"
export * from "./BaseDraggableWindow.vue?vue&type=script&lang=js"

import "./BaseDraggableWindow.vue?vue&type=style&index=0&id=0ea158d7&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea158d7"]])

export default __exports__